module.exports = __webpack_public_path__ + "static/find-your-store-cdn-f496dacf2474f075e6ab63102db9d5f5.png";